<div class="flex flex-column gap-3 justify-content-center align-content-center align-items-center text-center">
    <div>
        <span class="title">
            <app-translate key="AUTO_REFRESH_MESSAGE"></app-translate>
        </span>
    </div>
    <div>
        <span class="title">
            <app-translate key="KEEP_PAGE_OPEN"></app-translate>
        </span>
    </div>
    <div>
        <p-progressSpinner></p-progressSpinner>
    </div>
    <div>
        @if (success) {
        <span class="sub-title">
            <app-translate key="SUBMIT_SUCCESS_MESSAGE"></app-translate>
        </span>
        } @else {
        <span class="sub-title">
            <app-translate key="DATA_COLLECTION_CANCELED"></app-translate>
        </span>
        }
    </div>
</div>